module.exports = __webpack_public_path__ + "img/banner-hen-en.c1381cf4.png";